import { Location } from '@cobliteam/common-types';
import PathAssociationRouter from '../pages';
import PathAssociationPage from '../pages/PathAssociationPage';
import VehiclePathsPage from '../pages/VehiclePathsPage';

const routes = [
  {
    path: Location.PATH_ASSOCIATION,
    component: PathAssociationRouter,
    featureFlag: 'enableDriverAssociationPast',
    routes: [
      {
        path: Location.PATH_ASSOCIATION_VEHICLE,
        component: VehiclePathsPage,
        exact: true,
      },
      {
        path: Location.PATH_ASSOCIATION,
        component: PathAssociationPage,
        exact: true,
      },
    ],
  },
];

export default routes;
